import { render, staticRenderFns } from "./NavbarAdmin.vue?vue&type=template&id=450e9655&scoped=true&"
import script from "./NavbarAdmin.vue?vue&type=script&lang=js&"
export * from "./NavbarAdmin.vue?vue&type=script&lang=js&"
import style0 from "./NavbarAdmin.vue?vue&type=style&index=0&id=450e9655&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450e9655",
  null
  
)

export default component.exports